import React from 'react';
import { MarketDataCardProps } from '@/components/card/types';
import { renameDomProps } from '@/utils/sanitizeDomProps';
import { BaseImage } from '@/components/baseImage/BaseImage';

const MarketDataCard: React.FC<MarketDataCardProps> = React.memo(
  ({
    title,
    subtitle,
    description,
    link,
    className,
    price,
    changes,
    image,
    ...rest
  }) => {
    const renamedProps = renameDomProps(rest);
    return (
      <div
        data-component-sub-id={''}
        className={`content-card flex flex-col gap-[20px] rounded-xl border border-stone-200 bg-white p-6 text-brand-700 ${className}`}
        {...renamedProps}
      >
        <section className="flex flex-row items-center justify-start gap-2">
          {image ? (
            <BaseImage
              image={{ url: image }}
              width="32"
              height="32"
              alt="Market Data Card"
              className="h-8 w-8"
              classNameImage="h-8 w-8"
              sizes="32px"
            />
          ) : (
            <div className="h-8 w-8 rounded-full bg-green-50"></div>
          )}
          <section className="flex flex-col">
            <h3 className="text-sm font-[450] text-[#2C2C2C]">{title}</h3>
            <p className="text-sm font-[400] text-neutral-500">{subtitle}</p>
          </section>
        </section>
        <div className="flex flex-col gap-[6px]">
          {price && (
            <p className="text-base font-[450] text-[#2C2C2C]">{price}</p>
          )}
          {changes && (
            <p
              className={`text-base font-[450] ${
                changes.startsWith('+') ? 'text-[#77B900]' : 'text-[#E8464C]'
              }`}
            >
              {changes}
            </p>
          )}
        </div>
      </div>
    );
  },
);

MarketDataCard.displayName = 'MarketDataCard';

export default MarketDataCard;
